<template>
	<datatable :headers="headers" :value="items" :rows="10" :loading :paginator="false">
		<template #row-distance="{ row }"> {{ parseInt(row.distance) }} miles </template>

		<template #row-fulfilment="{ row }">
			<div class="flex items-center justify-between">
				{{ parseInt(row.fulfilment) }}%

				<div>
					<app-tooltip v-if="row.can_fulfil" text="Stock Available" position-x="right">
						<font-awesome-icon
							icon="fa-regular fa-check-circle"
							class="h-5 text-green-400" />
					</app-tooltip>

					<app-tooltip v-else text="Stock Unavailable" position-x="right">
						<font-awesome-icon
							icon="fa-regular fa-circle-xmark"
							class="h-5 text-red-400" />
					</app-tooltip>
				</div>
			</div>
		</template>
	</datatable>
</template>

<script lang="ts" setup>
	import type { Header, Row } from '@/data/types/datatable'

	const headers: Header[] = [
		{ value: 'depot', text: 'Depot', props: { sortable: true } },
		{ value: 'depot_name', text: 'Name', props: { sortable: true } },
		{ value: 'distance', text: 'Distance', props: { sortable: true } },
		{ value: 'fulfilment', text: '% Fulfilled', props: { sortable: true } }
	]

	defineProps({
		items: {
			type: Array<Row>,
			default: []
		},
		loading: Boolean
	})
</script>
